import { c as _c } from "react/compiler-runtime";
import { TweetBody, TweetHeader } from "react-tweet";
import type { EnrichedTweet } from "./ExpandableTweetPreview.types";
export default function CompactTweetContent(t0) {
  const $ = _c(2);
  const {
    tweet
  } = t0;
  let t1;
  if ($[0] !== tweet) {
    t1 = <><TweetHeader tweet={tweet} /><TweetBody tweet={tweet} /></>;
    $[0] = tweet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}